export enum DealerChannel {
  LSP = "lsp",
  MDU = "mdu",
  D2D = "d2d",
  EM = "em",
  NR = "nr",
  ISP = "isp",
}
